import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { myHoursQueries } from './my-hours.queries';

/**
 * Fetch labor entries for a user for a specific week (non-suspense, for progressive loading)
 */
export function useMyWeekLaborQuery(userId: number, weekString: string) {
  return useQuery({
    ...myHoursQueries.week(userId, weekString),
    enabled: userId > 0,
  });
}
